import * as React from "react";
import { styled } from "@mui/material";
import { KahunTitleCard } from "../../layout/kahunTitleCard";
import { PatientCardDdView, SubHeader } from "../commonPatientCardDd";
import { onAddonAndThemeBreakPoint } from "../patientCardCommonUi";
import { CommonColors } from "../../colors/commonColors";
import clsx from "clsx";

//region [[ Styles ]]
const PatientCardSectionTemplateView = styled("div")({
  display: "flex",
  flexFlow: "column",
  flex: 2,
  "&.flex-1": {
    flex: 1,
  },
});

export const MobileSectionInfoText = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "none",
  "& span": {
    margin: "0 5px",
  },
  ...onAddonAndThemeBreakPoint(theme.breakpoints.down("md"), {
    display: "flex",
    color: CommonColors.Default,
    fontWeight: 700,
    fontSize: "17px",
    lineHeight: "19px",
    margin: "3px 20px",
    width: "calc(100% - 40px)",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
  }),
}));

export const DesktopSectionInfoText = styled("div")(({ theme }) => ({
  display: "flex",
  color: CommonColors.Default,
  fontWeight: 700,
  fontSize: "17px",
  lineHeight: "19px",
  width: "calc(100% - 40px)",
  justifyContent: "space-between",
  alignItems: "center",
  ...onAddonAndThemeBreakPoint(theme.breakpoints.down("md"), {
    display: "none",
  }),
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientCardSectionTemplateProps {
  title: React.ReactNode;
  content: React.ReactNode;
  flex?: number;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientCardSectionTemplate = ({
  title,
  content,
  flex = 1,
  ...props
}: PatientCardSectionTemplateProps) => {
  return (
    <PatientCardSectionTemplateView
      className={clsx(props.className, `flex-${flex}`)}
    >
      <MobileSectionInfoText className={"mobile-section-info-text"}>
        {title}
      </MobileSectionInfoText>
      <KahunTitleCard className={"kahun-title-card"}>
        <PatientCardDdView className={"patient-card-dd-view"}>
          <DesktopSectionInfoText>
            <SubHeader>{title}</SubHeader>
          </DesktopSectionInfoText>
          {content}
        </PatientCardDdView>
      </KahunTitleCard>
    </PatientCardSectionTemplateView>
  );
};
